<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("Renunciation") }}
      </div>
      <router-link class="btn-blue" to="/user-management/renunciation"
        >{{ $t("Renunciation") }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedUser.length > 0 ? 'shift-up' : ''">
                {{ $t("select") }}
                {{ $tc("user", 1) }}
              </label>
              <b-dropdown
                :text="selectedUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search User"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchUser($event.target.value)"
                    v-on:keydown="onSearchUser($event.target.value)"
                    v-on:search="onSearchUser($event.target.value)"
                    v-model="searchUser"
                  />
                </div>
                <b-dropdown-item
                  v-for="(user, userIndex) in users"
                  :key="userIndex"
                  @click="onSelectHandler(user)"
                  name="selectuser"
                  id="selectuser"
                  >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <!-- <Tooltip :title="$t('selectuser_renunciation')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedUser.length == 0"
              >Please Select User.</span
            >
          </p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-on:click="cleardoj()">✖</button>
                <Datepicker :monday-first="true"  ref="programaticOpen" name="doj" id="doj" v-validate="'required'"></Datepicker>
                <label class="active">{{ $t('doj') }}</label>
              </div>
            </div>
            <Tooltip :title="``"  />
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>-->

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="dol"
                  v-on:click="cleardoj()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="dol"
                  name="dateleaving"
                  id="dateleaving"
                  :typeable="true"
                  v-validate="'required'"
                  :disabledDates="{
                    from: new Date(),
                  }"
                ></Datepicker>
                <label :class="typeof dol === 'object' ? 'active' : ''">{{
                  $t("dol")
                }}</label>
              </div>
            </div>
            <!-- <Tooltip :title="$t('dateofleaving_renunciation')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('dateleaving')">{{
              errors.first("dateleaving")
            }}</span>
          </p>
        </div>

        <div class="col-lg-12 col-xl-12 align-self-center mb-4">
          <div class="d-flex align-items-center pr-28px">
            <div class="input-material-textarea">
              <textarea
                rows="1"
                placeholder="."
                v-model="leavingreason"
                name="renunciationremark"
                id="renunciationremark"
                v-validate="'required'"
              ></textarea>
              <label :class="leavingreason.length > 0 ? 'shift-up' : ''">{{
                $t("rol")
              }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('renunciationremark')">{{
              errors.first("renunciationremark")
            }}</span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit()"
          >
            {{ $t("submit") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      btenable: false,
      users: [],
      selectedUser: "",
      selectedUserid: "",
      dol: "",
      leavingreason: "",
      errmsg: "",
      submitted: false,
      searchUser: "",
      usersCopy: [],
    };
  },
  beforeMount() {
    this.getUserList();
  },
  methods: {
    onSearchUser: function (value) {
      if (this.searchUser && this.searchUser.length > 0) {
        this.users = this.usersCopy.filter((x) => {
          if (
            x.first_name
              .concat(x.last_name)
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.users = this.usersCopy;
      }
    },
    getUserList: function () {
      let body = {
        limit: null,
        currentPage: null,
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.users = data.data;
            this.usersCopy = data.data;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectHandler: function (event) {
      console.log("event :", event);
      let first_last = event.first_name + " " + event.last_name;
      this.selectedUser = first_last;
      this.selectedUserid = event.user_id;
      console.log("this.selectedUser :", this.selectedUser);
    },
    cleardoj() {
      this.dol = "";
    },
    ResetForm() {
      this.selectedUser = "";
      this.dol = "";
      this.leavingreason = "";
    },
    onFinalSubmit() {
      this.submitted = true;
      if (this.selectedUser.length == 0) {
        return;
      } else {
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            this.btenable = true;

            let payload = {
              userid: this.selectedUserid,
              leavingdate: this.dol,
              reason: this.leavingreason,
            };

            UserService.AddRenunciation(payload).then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.Status) {
                this.ResetForm();
                this.$router.push({
                  path: "/user-management/renunciation",
                });
              }
            });
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/RenunciationComponents/addrenunciation.vue